var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.061 22.125C15.998 30.087 23.223 37.066 32.006 37.066C41.426 37.066 49.061 29.042 49.061 20.383C49.061 20.309 49.056 20.237 49.055 20.166C39.337 18.847 26.956 25.908 15.061 22.125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 20.445C54 9.042 48.292 2.002 48.291 2H15.708C15.708 2 10 9.052 10 20.445C10 31.273 19.256 41.331 30.895 41.934C30.759 48.222 30.224 54.77 28.684 57.038C26.515 60.234 18.913 58.592 18.913 62H45.09C45.09 58.591 37.485 60.234 35.316 57.038C33.776 54.77 33.241 48.223 33.105 41.934C44.741 41.332 54 31.273 54 20.445ZM32 39.254C22.206 39.254 14.15 31.473 13.106 22.596C13.0276 21.9519 12.9872 21.3038 12.985 20.655C12.985 10.805 17.918 4.711 17.918 4.711H46.081C46.082 4.714 50.927 10.7 51.008 20.413C51.009 20.493 51.015 20.572 51.015 20.655C51.015 30.308 42.502 39.254 32 39.254Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/wine.177528532bdcc3753ba88236a6e13dca.svg";
export { ForwardRef as ReactComponent };